import { Flex, Group, Pill, Stack, Text } from '@mantine/core';

import { Content, EditButtonLink } from '@/core/components';

import { LanguagePill } from '@feature/utils';

import { Journal } from './model/JournalTypes';

interface JournalViewProps {
  journal: Journal;
}

export function JournalView(props: JournalViewProps) {
  const { journal } = props;
  const { title, publisher, language, bdis, issn, isUmfstOwned, wosId } = journal;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Group>
              {wosId && (
                <Pill
                  bg="green"
                  c="white"
                >
                  Sincronizat cu JCR
                </Pill>
              )}
              {isUmfstOwned ? (
                <Pill
                  bg="blue"
                  c="white"
                >
                  Revistă UMFST
                </Pill>
              ) : null}
              <Text fw="500">{title}</Text>
            </Group>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              {/*<JournalDeleteButton journalId={journal.id} /> TODO ENABLE AFTER SECURITY CHECK*/}
            </Group>
          </Flex>
          <Stack>
            <Text
              fw="500"
              c="dimmed"
            >
              Cod wos: {wosId}
            </Text>
            <Text
              c="dimmed"
              size="sm"
            >
              {publisher?.title}
            </Text>
          </Stack>
        </Stack>
        <div>
          <LanguagePill language={language} />
        </div>
      </Content>

      <Content type="full">
        <Text fw="500">ISSN</Text>
        <Group>
          {(issn ?? []).map(i => (
            <Pill key={i.id}>{i.code}</Pill>
          ))}
        </Group>
      </Content>

      <Content type="full">
        <Text fw="500">Indexări BDI</Text>
        {bdis.length > 0 && (
          <Group>
            {(bdis ?? []).map(i => (
              <Pill key={i.id}>{i.name}</Pill>
            ))}
          </Group>
        )}
      </Content>
    </Stack>
  );
}
